import React from 'react';

const ApproveRecurringFileIcon = ({
  onlyApprove,
}: {
  onlyApprove?: boolean;
}): JSX.Element =>
  onlyApprove ? (
    <svg
      fill="none"
      height="42"
      viewBox="0 0 43 42"
      width="43"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.7956 31.145V4.34945C27.7956 3.46112 27.4427 2.60917 26.8146 1.98103C26.1864 1.35289 25.3345 1 24.4461 1H4.34945C3.46112 1 2.60917 1.35289 1.98103 1.98103C1.35289 2.60917 1 3.46112 1 4.34945V31.145L7.6989 27.7956L14.3978 31.145L21.0967 27.7956L27.7956 31.145Z"
        stroke="#219653"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.66567"
      />
      <path
        d="M6 8H18"
        stroke="#219653"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        d="M6 15H22"
        stroke="#219653"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <circle
        cx="31.4228"
        cy="29.9438"
        fill="#219653"
        r="10.4121"
        stroke="white"
        strokeWidth="1.67"
      />
      <g clipPath="url(#clip0_22872_324052)">
        <path
          d="M36.9581 25.8428H35.9912C35.8556 25.8428 35.727 25.905 35.644 26.0115L29.9409 33.2362L27.2062 29.7712C27.1648 29.7187 27.1121 29.6762 27.052 29.647C26.9919 29.6177 26.9259 29.6025 26.859 29.6024H25.8921C25.7995 29.6024 25.7483 29.7089 25.805 29.7809L29.5937 34.5807C29.7707 34.8048 30.111 34.8048 30.2895 34.5807L37.0452 26.0198C37.1019 25.9493 37.0508 25.8428 36.9581 25.8428Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_22872_324052">
          <rect
            fill="white"
            height="12.3939"
            transform="translate(25.2266 24.1001)"
            width="12.3939"
          />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg
      fill="none"
      height="42"
      viewBox="0 0 43 42"
      width="43"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.7956 31.145V4.34945C27.7956 3.46112 27.4427 2.60917 26.8146 1.98103C26.1864 1.35289 25.3345 1 24.4461 1H4.34945C3.46112 1 2.60917 1.35289 1.98103 1.98103C1.35289 2.60917 1 3.46112 1 4.34945V31.145L7.6989 27.7956L14.3978 31.145L21.0967 27.7956L27.7956 31.145Z"
        stroke="#FAAD14"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.66567"
      />
      <path
        d="M6 8H18"
        stroke="#FAAD14"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        d="M6 15H22"
        stroke="#FAAD14"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <circle
        cx="31.4228"
        cy="29.9438"
        fill="#FAAD14"
        r="10.4121"
        stroke="white"
        strokeWidth="1.67"
      />
      <path
        d="M30.5 33.8214C30.5 34.134 30.6242 34.4338 30.8452 34.6548C31.0662 34.8758 31.366 35 31.6786 35C31.9911 35 32.2909 34.8758 32.5119 34.6548C32.733 34.4338 32.8571 34.134 32.8571 33.8214C32.8571 33.5089 32.733 33.2091 32.5119 32.9881C32.2909 32.767 31.9911 32.6429 31.6786 32.6429C31.366 32.6429 31.0662 32.767 30.8452 32.9881C30.6242 33.2091 30.5 33.5089 30.5 33.8214ZM31.0893 31.0714H32.2679C32.3759 31.0714 32.4643 30.983 32.4643 30.875V24.1964C32.4643 24.0884 32.3759 24 32.2679 24H31.0893C30.9813 24 30.8929 24.0884 30.8929 24.1964V30.875C30.8929 30.983 30.9813 31.0714 31.0893 31.0714Z"
        fill="white"
      />
    </svg>
  );

export default ApproveRecurringFileIcon;
